<template>
  <svg width="6" height="28" viewBox="0 0 6 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="3" cy="3" r="3" fill="#2C2738"/>
    <circle cx="3" cy="14" r="3" fill="#2C2738"/>
    <circle cx="3" cy="25" r="3" fill="#2C2738"/>
  </svg>
</template>

<script>
import iconMixin from "@/services/iconMixins.js";

export default {
  mixins: [iconMixin]
};
</script>
